// istanbul ignore file
// TODO APPS-11349-add-coverage-remove-istanbul-ignore
import React, { forwardRef, ReactNode } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { PageTitle } from './components/PageTitle/PageTitle';
import { ActionsGroup } from './components/ActionsGroup';

export const Root = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${globalTheme.spacing.lg};
`;

export const MobileActionsWrapper = styled.div`
  margin-bottom: ${globalTheme.spacing.lg};
  display: flex;
  justify-content: space-between;
`;

export interface TransformationsHeaderProps {
  mainTitle: ReactNode;
  subtitle: ReactNode;
  children: ReactNode;
}

export interface TransformationsHeaderComposition {
  MobileActionsWrapper: typeof MobileActionsWrapper;
}

const TransformationsHeaderParent = forwardRef<HTMLDivElement, TransformationsHeaderProps>(
  ({ mainTitle, subtitle, children }: TransformationsHeaderProps, ref) => {
    return (
      <Root ref={ref} data-test="transformations-header">
        <PageTitle title={mainTitle} subtitle={subtitle} />
        <ActionsGroup>{children}</ActionsGroup>
      </Root>
    );
  }
);

export const TransformationsHeader = Object.assign(TransformationsHeaderParent, { MobileActionsWrapper });
